import styled from 'styled-components';
import theme, { textBold } from 'theme/theme';

const FieldError = styled.div`
  padding: 5px 0;
  color: ${theme.colors.primary};
  background: ${theme.colors.white};
  ${textBold};
  font-size: ${theme.fontSizes.small};
`;

export default FieldError;
